import { render } from "./MenuItem.vue?vue&type=template&id=56d93100"
import script from "./MenuItem.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuItem.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"assets/admin/js/cms/MenuItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "56d93100"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('56d93100', __exports__)) {
    api.reload('56d93100', __exports__)
  }
  
  module.hot.accept("./MenuItem.vue?vue&type=template&id=56d93100", () => {
    api.rerender('56d93100', render)
  })

}


export default __exports__